<div [class]="showPagingButtons | responsiveCSSClass : 'hiddenTinyView'" class="paging-left">
  <pdf-first-page style="margin-right: -3px"></pdf-first-page>
  <pdf-previous-page style="margin-left: -3px"></pdf-previous-page>
</div>
<pdf-page-number [class]="showPagingButtons | responsiveCSSClass : 'hiddenXXSView'"></pdf-page-number>
<div [class]="showPagingButtons | responsiveCSSClass : 'hiddenTinyView'" class="paging-right">
  <pdf-next-page style="margin-right: -3px; margin-left: -3px"></pdf-next-page>
  <pdf-last-page style="margin-left: -3px"></pdf-last-page>
</div>
